import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { DoorHangerIcon } from "@/shared/icons";

type Props = {
  count: number;
};

export default function HotelRoomsInfo({ count }: Props) {
  const { t } = useTranslation("hotel");

  return (
    <div className="relative z-1 flex items-center gap-1.5 mx-5 px-3 py-1 border border-[#1C1C1C] rounded-xl">
      <DoorHangerIcon className="w-4" />
      <p className="text-14 font-medium text-white/70 leading-none">{t("hotel.emptyNumbers")}:</p>
      <p
        className={clsx(
          "ml-auto text-14 font-bold leading-none",
          count ? "text-[#84FF97]" : "text-accent-solid",
        )}
      >
        {count || t("hotel.no")}
      </p>
    </div>
  );
}
